import { render, staticRenderFns } from "./SelectFile.vue?vue&type=template&id=37f7d5ae&"
import script from "./SelectFile.vue?vue&type=script&lang=ts&"
export * from "./SelectFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VAlert,VFileInput})
